import React from 'react';

const styles = {
  page: {
    fontFamily: 'Arial, sans-serif',
    lineHeight: 1.6,
    margin: 0,
    padding: '40px 20px',
    backgroundColor: '#f4f4f4',
    minHeight: '100vh',
    boxSizing: 'border-box',
  },
  container: {
    maxWidth: '900px',
    margin: '0 auto',
    padding: '30px',
    background: '#ffffff',
    borderRadius: '10px',
    boxShadow: '0 0 10px rgba(0,0,0,0.1)',
  },
  h1: {
    color: '#333',
    textAlign: 'center',
    marginBottom: '24px',
  },
  h2: {
    color: '#333',
    marginTop: '28px',
    marginBottom: '10px',
  },
  p: {
    color: '#555',
    marginBottom: '14px',
  },
  ul: {
    marginLeft: '20px',
    color: '#555',
    marginBottom: '14px',
  },
  footer: {
    marginTop: '30px',
    fontSize: '14px',
    color: '#777',
    textAlign: 'center',
  },
};

function PrivacyPadrao() {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.h1}>Política de Privacidade</h1>

        <p style={styles.p}>
          <strong>Última atualização:</strong> 02 de maio de 2026
        </p>

        <p style={styles.p}>
          Esta Política de Privacidade descreve como os aplicativos{' '}
          <strong>Mind Slice</strong>, <strong>Stack Ninja</strong>, <strong>Tap Perfect</strong>, <strong>InfinityCalc</strong>, <strong>Cara ou Coroa</strong>, <strong>Conversor de Unidades</strong> e <strong>Moeda Pro</strong>, desenvolvido por{' '}
          <strong>Tassio Sirqueira</strong>, tratam as informações dos usuários.
        </p>

        <p style={styles.p}>
          Ao utilizar estes aplicativos, você concorda com os termos desta Política
          de Privacidade.
        </p>

        <h2 style={styles.h2}>1. Coleta de Informações</h2>
        <p style={styles.p}>Os aplicativos:</p>
        <ul style={styles.ul}>
          <li>Não coletam dados pessoais do usuário</li>
          <li>Não possuem sistema de login ou cadastro</li>
          <li>Não armazenam informações sensíveis</li>
        </ul>

        <p style={styles.p}>
          No entanto, podem ser coletadas informações automaticamente por serviços
          de terceiros.
        </p>

        <h2 style={styles.h2}>2. Anúncios e Serviços de Terceiros</h2>
        <p style={styles.p}>
          Estes aplicativos utilizam serviços de publicidade, como o Google AdMob,
          que podem coletar automaticamente informações para exibir anúncios
          relevantes.
        </p>

        <p style={styles.p}>Essas informações podem incluir:</p>
        <ul style={styles.ul}>
          <li>Identificadores de dispositivo</li>
          <li>Dados de uso do aplicativo</li>
          <li>Endereço IP (de forma anonimizada)</li>
        </ul>

        <h2 style={styles.h2}>3. Uso das Informações</h2>
        <p style={styles.p}>
          As informações coletadas automaticamente por terceiros são utilizadas
          para:
        </p>
        <ul style={styles.ul}>
          <li>Exibição de anúncios</li>
          <li>Melhoria da experiência do usuário</li>
          <li>Análise de desempenho dos anúncios</li>
        </ul>

        <h2 style={styles.h2}>4. Segurança</h2>
        <p style={styles.p}>
          Como os aplicativos não coletam nem armazenam dados pessoais diretamente,
          os riscos relacionados à segurança de dados são minimizados.
        </p>

        <h2 style={styles.h2}>5. Privacidade de Crianças</h2>
        <p style={styles.p}>
          Os aplicativos podem ser utilizados por usuários de todas as idades.
          Recomenda-se supervisão de responsáveis no uso por crianças.
        </p>

        <h2 style={styles.h2}>6. Permissões do Aplicativo</h2>
        <ul style={styles.ul}>
          <li>Acesso à internet → necessário para exibição de anúncios</li>
        </ul>

        <h2 style={styles.h2}>7. Direitos do Usuário</h2>
        <p style={styles.p}>
          Como os aplicativos não coletam nem armazenam dados pessoais diretamente, não há
          armazenamento de dados a ser acessado ou excluído.
        </p>

        <h2 style={styles.h2}>8. Alterações nesta Política</h2>
        <p style={styles.p}>
          Esta Política de Privacidade pode ser atualizada periodicamente.
        </p>

        <h2 style={styles.h2}>9. Contato</h2>
        <p style={styles.p}>Email: tassio@tassio.eti.br</p>
        <p style={styles.p}>Desenvolvedor: Tassio Sirqueira</p>

        <div style={styles.footer}>
          <p>&copy; 2026+ - Todos os direitos reservados</p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPadrao;